import GetPaidEarlyScreen from 'features/onboarding/screens/GetPaidEarly/GetPaidEarlyScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function OnboardingGetPaidEarlyPage() {
  return (
    <PinwheelContextProvider>
      <GetPaidEarlyScreen />
    </PinwheelContextProvider>
  );
}
